import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { H1 } from 'components/common/Text/Text'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import Theme from 'components/common/Theme/Theme'
import Portal from 'components/common/Portal/Portal'
import ProgressLineElement from './components/ProgressLineElement'
import { BOT_APPOINTMENT_PROGRESS_BAR_ID } from 'constant'

const BOTMakeAppointmentHeader = ({
  id,
  description,
  title,
  steps,
  placeholders: { steps: stepsPlaceholder = []} = {},
  setBlockRef,
  completedSteps,
  allStepsCompleted,
  isScrolledToEdge,
  onClickHandler
}) =>
  <Fragment>
    <div>
      <Portal id={ BOT_APPOINTMENT_PROGRESS_BAR_ID }>
        {
          isScrolledToEdge &&
            <ProgressBar>
              {
                steps.map(({ icon, collapsedTitle }, index) =>
                  <ProgressLineElement
                    key={ index }
                    asset={ icon }
                    title={ collapsedTitle }
                    padding={ 80 }
                    { ...completedSteps[index] } />
                )
              }
              {
                allStepsCompleted &&
                  <ProgressLineElement button title="Continue" onClick={ onClickHandler } />
              }
            </ProgressBar>
        }
      </Portal>
    </div>
    <Wrapper>
      <MakeAppointmentHeaderContainer id={ id }>
        <Headline data-make-an-appointment-header-title headline bolder noMargin>{ title }</Headline>
        <SubHead data-make-an-appointment-header-subhead>{ description }</SubHead>
        <StepWrapper>
          {
            React.Children.map(stepsPlaceholder, (content, index) =>
              React.cloneElement(content, {
                key: index,
                stepInfo: completedSteps[index],
                isDone: completedSteps[index].isDone
              })
            )
          }
        </StepWrapper>
      </MakeAppointmentHeaderContainer>
    </Wrapper>
  </Fragment>

BOTMakeAppointmentHeader.propTypes = {
  allStepsCompleted: PropTypes.bool,
  completedSteps: PropTypes.arrayOf(PropTypes.shape()),
  description: PropTypes.string,
  id: PropTypes.string,
  isScrolledToEdge: PropTypes.bool,
  onClickHandler: PropTypes.func,
  placeholders: PropTypes.shape({
    stepsPlaceholder: PropTypes.arrayOf()
  }),
  setBlockRef: PropTypes.func,
  steps: PropTypes.arrayOf(PropTypes.shape()),
  title: PropTypes.string
}

export default BOTMakeAppointmentHeader

const Wrapper = styled.div`
  background: ${Theme.colors.off_white};
`

const MakeAppointmentHeaderContainer = styled.div`
  text-align: center;
  ${Mixin.responsive('padding', '30px 40px 25px', '30px 16px 0')}
`

const Headline = styled(H1)`
  ${Mixin.responsive('line-height', '68px', '40px')}
  ${Media.desktop`
    font-size: 48px;
  `}
`

const SubHead = styled.div`
  ${Mixin.font.GothamBook(20, 400)}
  ${Mixin.desktopOnly()}
`

const StepWrapper = styled.div`
  display: table;
  width: 100%;
  padding-top: 27px;
  ${Media.mobile`
    display: flex;
    flex-wrap: wrap;
  `}
`

const ProgressBar = styled.div`
  display: table;
  table-layout: fixed;
  width: 100%;
  z-index: 999; /* @TODO */
  border: 1px solid ${Theme.colors.light_grey};
  box-shadow: 0 1px 4px ${Theme.colors.transparent_overlay_shadow};
  background-color: ${Theme.colors.white};
`
